import styled, { keyframes } from 'styled-components';
import { Color, Font, breakpoints, ColorDark } from "@/shared/Constants";

const slideInRight = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const slideOutRight = keyframes`
  from { transform: translateX(0); opacity: 1; }
  to   { transform: translateX(100%); opacity: 0; }
`;


// Styled Components
export const ModalDialog = styled.dialog`
  border: none;
  padding: 0;
  max-width: none;
  max-height: none;
  margin: 0;
  margin-left: auto;

  background: white;
  width: 400px;
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  overflow-y: auto;
  flex-direction: column;

  display: none;
  &[open] {
    display: flex;
  }

  /* Animación de entrada */
   animation: ${slideInRight} 260ms cubic-bezier(.22,.61,.36,1) both;
   will-change: transform, opacity; 
   @media (prefers-reduced-motion: reduce) {
     animation: none;
   }

    &.isClosing {
    animation: ${slideOutRight} 220ms ease-in forwards;
  }

  &::backdrop {
    background: rgba(0, 0, 0, 0.5);
  }

  @media (max-width: 768px) {
    width: 100%;
    height: 100vh;
  }

  ${breakpoints.darkMode} {
    [data-theme='dark'] & {
      background-color:${ColorDark.darkGrey};
    }
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.2rem;
  h2{
    ${Font.sansRegular}
    font-size: 24px;
    line-height: 19px;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
        color:${ColorDark.textLight};
      }
    }
  }
  button {
    all: unset;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    width: 32px;
    border-radius: 8px;
    border: 1px solid ${Color.greyC2C2C2};
    cursor: pointer;
    > div {
      max-width: 18px;
      max-height: 18px;
    }
  ${breakpoints.darkMode} {
    [data-theme='dark'] & {
      border: 1px solid ${ColorDark.textLight};
      svg {
        fill: ${ColorDark.textLight};
      }
    }
  }
  }
`;

export const ModalBody = styled.div`
  height: 100%;
  max-height: 90vh;
  overflow-y: auto;
  .no_notify{
    height: 100%;
    display: grid;
    place-content: center;
    p{
      ${Font.sansLight}
      font-size: 16px;
      margin: 0;
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
          color:${ColorDark.textLight};
        }
      }
    }
  }
`;

export const ItemNotify = styled.div`
 width: 100%;
 padding: 1rem 1.2rem;
 /* background-color: ${Color.weatherGray}; */
 border-bottom: 1px solid ${Color.weatherGray};
 display: flex;
 flex-direction: column;
 gap: 1rem;
 h3 {
    ${Font.sansRegular}
    font-size: 16px;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
        color:${ColorDark.textLight};
      }
    }
 }  
 p {
    ${Font.sansLight}
    font-size: 16px;
    color: ${Color.grey666};
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
        color:${ColorDark.textLight};
      }
    }
 }
 .containerImage{
    display: grid;
    place-content: center;
    width: 100%;
    height: 180px;
    border-radius: 12px;
    overflow: hidden;
    img {
      object-fit: contain;
      height: 185px;
      width: auto;
    }
  }
 .btn_group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  gap: .75rem;
  button {
    all: unset;
    display: grid;
    place-content: center;
    ${Font.sansRegular}
    font-size: 13px;
    background-color: ${Color.white};
    border: 1px solid ${Color.greyC2C2C2};
    border-radius: 4px;
    height: 30px;
    cursor: pointer;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
        color:${ColorDark.textLight};
        border: 1px solid ${Color.textLight};
        background-color: ${ColorDark.backDarknew};
      }
    }
  }
 }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 200px;
  left: 0;
  width: 100%;
  height: calc(100vh - 200px);
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: flex-end;
  z-index: 10000;

  @media (max-width: 768px) {
    top: 0;
    height: 100vh;
    justify-content: stretch;
  }
`;

export const NotificationButton = styled.button`
  position: relative;
  background: transparent;
  border: none;
  cursor: pointer;
  margin-left: auto;
  margin-right: 0;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  display: none; //se oculta hasta nuevo aviso
  svg {
    max-width: 30px;
    max-height: 30px;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
        color:${ColorDark.textLight};
      }
    }
  }
  &::before,
  &::after {
    position: absolute;
    top: 50%;
    right: 10px;
    translate: 50% -50%; 
  }

  &.has-notifications::before {
    content: "";
    width: .7em; 
    height: .7em;
    background: red;
    border: 2px solid #fff;
    border-radius: 50%;
    z-index: 2;
    pointer-events: none;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
        border: 2px solid ${ColorDark.backDarknew};
      }
    }
  }

  &.has-notifications::after {
    content: "";
    width: .8em; 
    height: .8em;
    background: rgba(255,0,0,.7);
    border-radius: 50%;
    z-index: 1;
    pointer-events: none;
    transform-origin: center;
    animation: radarScale 1.5s infinite;
    will-change: scale, opacity;
  }

  @keyframes radarScale {
    0%   { scale: .9; opacity: .7; }
    70%  { scale: 2.2; opacity: 0; }
    100% { scale: 2.4; opacity: 0; }
  }
`;

